/*
 * @Author: 吴文洁
 * @Date: 2019-09-20 15:52:08
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-03 19:44:37
 * @Description:
 */
import BenefitService from '@/service/BenefitService';

const studentModule = {
  state: {
    totalWheat: {},
  },

  mutations: {
    setTotalWheat(state, totalWheat) {
      state.totalWheat = totalWheat;
    },
  },

  actions: {
    setTotalWheat({ commit }, totalWheat) {
      commit('setTotalWheat', totalWheat);
    },
  },
};

export default studentModule;



// WEBPACK FOOTER //
// ./src/store/modules/student.js